import {
  ArrayMinSize,
  IsArray,
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
  ValidateIf,
} from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';
import { CleaningFrequency, isPeriodicCleaningFrequency } from './cleaning-frequency.enum';
import { DayOfWeek } from './day-of-week.enum';

export class CreateCleaningAreaDto {
  @IsString()
  @IsNotEmpty()
  name!: string;

  @IsString()
  @IsNotEmpty()
  icon!: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  description?: string;

  // Omitted = WEEKLY_DAYS, so clients that predate the field keep working.
  @IsEnum(CleaningFrequency)
  @IsOptional()
  frequency?: CleaningFrequency;

  // Required for weekly areas; periodic areas carry none (the backend stores []).
  @ValidateIf((dto: CreateCleaningAreaDto) => !isPeriodicCleaningFrequency(dto.frequency))
  @IsArray()
  @ArrayMinSize(1)
  @IsEnum(DayOfWeek, { each: true })
  scheduledDays?: DayOfWeek[];

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  products?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  procedure?: string;
}
